





























































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import LeftNavigationComponent from "../../Workspace/Components/LeftNavigation.vue";
import NoCostExtension from './NoCostExtension.vue';
import BudgetRevision from './BudgetRevision.vue';
import GrantSuspension from './GrantSuspension.vue';
import GrantTermination from './GrantTermination.vue';
import { User } from "oidc-client";
import AuthService from "@/services/auth.service";
import { AppConstants as _app } from "@/shared/app.constants";
import { GrantData, GrantAmendmentData } from "@/entities";
import { Feedback } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import TechnicalRevision from './TechnicalRevision.vue';
import ValidationMessage from '@/components/common/ValidationMessage/ValidationMessage.vue';
import { Locales } from "@/i18n/locales";

const namespace: string = "grantAmendment";
const auth = new AuthService();

@Component({
    components: {
        LeftNavigationComponent,
        ProgressBar,
        WorkflowButtons,
        NoCostExtension,
        BudgetRevision,
        TechnicalRevision,
        ValidationMessage,
        GrantSuspension,
        GrantTermination
    }
})

export default class WorkspaceComponent extends Vue {
    @State(namespace) grantAmendment!: GrantAmendmentData;
    @State("feedback") feedback!: Feedback;
    @Action("getAmendmentDetailById", { namespace }) getAmendmentDetailById: any;
    @Action("getAmendmentById", { namespace }) getAmendmentById: any;
    @Action("UpdateAmendmentDetail", { namespace }) updateAmendmentDetail: any;
    @Action("UpdateAmendmentDetailData", { namespace }) updateAmendmentDetailData: any;
    @Action("showNotification", { namespace: "application" }) notify: any;
    @Action("getFeedbackInfo", { namespace: "feedback" }) getFeedbackInfo: any;
    @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
    @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
    @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
    @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
    @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number;

    saveloader: boolean = false;
    userTypeId?: number = null;
    internalUserTypes = [_app.UserType.SystemAdmin, _app.UserType.Secretariat];
    isInternalUser = false;
    actions = _app.actions;
    subjects = _app.subjects;
    componentKey = 0;
    isDirty: boolean = false;
    activeTabComponent: string;
    tabItems: any = [
        { component: "NoCostExtension", text: "Duration Modification", type: 'NoCost' },
        { component: "BudgetRevision", text: "Budget Modification", type: 'Budget' },
        { component: "TechnicalRevision", text: "Technical Modification", type: 'Technical' },
        { component: "GrantSuspension", text: "Suspension", type: 'Suspend' },
        { component: "GrantTermination", text: "Termination", type: 'Terminate' },
        { component: "NoCostExtension", text: "Resume Grant", type: 'Resume' },
    ];
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    mounted() {
        auth.isLoggedIn().then((isLoggedIn) => {
            if (isLoggedIn) {
                auth.getUser().then((user: User) => {
                    this.userTypeId = Number(user.profile.user_type_id);
                    this.isInternalUser = this.internalUserTypes.includes(this.userTypeId);
                });
            }
        });
    }

    /** computed property workflow items */
    get workFlowItems() {
        return this.grantAmendment.grantAmendmentDetail.WorkflowInfo || {}
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any) {
        if (changedRoute && changedRoute.name === 'amendmentDetail') {
            this.getAmendmentDetail();
            this.loadComponent();
        }
    }

    formatCurrency(val, currency) {
        return utils.formatCurrency(val, currency, this.defaultLocale);
    }

    getAmendmentDetail() {
        this.getAmendmentDetailById(this.$route.params.amendmentDetailId)
            .then((data) => {
                if (data) {
                    this.getFeedbackInfo({ entity: _app.entities.grantAmendmentDetail, transactionId: this.grantAmendment.grantAmendmentDetail.GrantAmendmentDetailId });
                    this.componentKey += 1;
                }
            });
    }

    getAmendment() {
        this.getAmendmentById(this.$route.params.amendmentId)
            .then((data) => {
                if (data) {
                }
            });
    }

    loadComponent() {
        this.activeTabComponent = this.tabItems
            .find(c => c.type === this.$route.params.amendmentType)
            .component;
    }

    back() {
        var grantAmendmentId = this.grantAmendment.grantAmendment.GrantAmendmentId.toString();
        this.$router.push({
            name: "amendment",
            params: { amendmentId: grantAmendmentId },
            hash: '#amendmentRequests'
        });
    }

    get formOptions() {
        return {
            //@ts-ignore
            "rights": this.$can("manage", "genericFeedback") ? _app.actions.manage : _app.actions.read,
            "entity": _app.entities.grantAmendmentDetail,
            "transactionId": this.grantAmendment.grantAmendmentDetail.GrantAmendmentDetailId,
            "user": this._userid,
            "feedbacks": this.feedback.feedbackHeaders,
            "actions": {
                createHeader: this.createFeedbackHeader,
                list: this.getFeedbacks,
                resolveFeedback: this.resolveFeedback,
                reopenFeedback: this.reopenFeedback,
                updateFeedback: this.$services.comment.Update
            }
        };
    }

    getFeedbackHeader(rowKey) {
        if (this.formOptions && this.formOptions.feedbacks) {
            return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
        } else {
            return null;
        }
    }

    feedbackInfo() {
        setTimeout(() => {
            this.getFeedbackInfo({ entity: _app.entities.grantAmendmentDetail, transactionId: this.grantAmendment.grantAmendmentDetail.GrantAmendmentDetailId });
        }, 1000)
    }

    setDirty(isDirty) {
        this.isDirty = isDirty;
    }

    saveAmendment() {
        this.saveloader = true;
        let amendmentType = this.$route.params.amendmentType;

        this.updateAmendmentDetailData({
            data: this.grantAmendment.grantAmendmentDetailData,
            id: this.grantAmendment.grantAmendmentDetail.GrantAmendmentDetailId,
            amendmentType: amendmentType
        }).then((data: any) => {
            this.componentKey += 1;
            this.saveloader = false;

            if (data.Result == 'ERROR') {
                this.notify({
                        text: data.Message,
                        isHtml: true,
                        color: "error",
                    }); 
            } else {
                this.isDirty = false;
                this.notify({
                    text: data.Message || this.$t('Your changes have been saved successfully.'),
                    isHtml: true,
                    color: "success",
                });
            }
        });
    }

    /** update the workflow status */
    updateStatus(item) {
        this.grantAmendment.grantAmendmentDetail.WorkflowStatusId = item.StepId;
        this.grantAmendment.grantAmendmentDetail.Comments = item.Comments;
        this.grantAmendment.grantAmendmentDetail.Subject = item.Subject;
        this.grantAmendment.grantAmendmentDetail.notify = item.notify;

        // Save changes on workflow status change
        if (this.isDirty) {
            this.saveAmendment();
        }

        this.updateAmendmentDetail({
            data: this.grantAmendment.grantAmendmentDetail,
            id: this.grantAmendment.grantAmendmentDetail.GrantAmendmentDetailId
        }).then(() => {
            this.getAmendmentDetail();
        });
    }

    /** open a read only view of application in new tab */
    openApplication() {
        var appSection = 'technicalApplication';

        if (this.grantAmendment.grantAmendmentDetail.AmendmentTypeId == 4900) {
            appSection = 'applicationBudget';
        } else if (this.grantAmendment.grantAmendmentDetail.AmendmentTypeId == 4901) {
            appSection = 'logFramework';
        }

        let routeData = null;
        routeData = this.$router.resolve({
            name: 'viewApplication',
            params: { appId: this.grantAmendment.grantInfo.ApplicationId, section: appSection },
        });

        window.open(routeData.href, "_blank");
    }

    get permission() {
        switch (this.grantAmendment.grantAmendmentDetail.AmendmentTypeId) {
            case 4899:
                //@ts-ignore
                return this.grantAmendment.grantAmendmentDetail.WorkflowStatusCode == 'INP' && this.$can(this.actions.update, this.subjects.noCostAmendment);

            case 4900:
                //@ts-ignore
                return (this.grantAmendment.grantAmendmentDetail.WorkflowStatusCode == 'INP' || this.grantAmendment.grantAmendmentDetail.WorkflowInfo.CurrentStep.ReturnStatus === 1) && (this.$can(this.actions.manage, this.subjects.budgetAmendment) || this.$can(this.actions.update, this.subjects.budgetAmendment))

            case 4901:
                //@ts-ignore
                return (this.grantAmendment.grantAmendmentDetail.WorkflowStatusCode == 'INP' || this.grantAmendment.grantAmendmentDetail.WorkflowInfo.CurrentStep.ReturnStatus === 1) && (this.$can(this.actions.manage, this.subjects.technicalAmendment) || this.$can(this.actions.update, this.subjects.technicalAmendment));

            case 4903:
                //@ts-ignore
                return this.grantAmendment.grantAmendmentDetail.WorkflowStatusCode == 'INP' && this.$can(this.actions.update, this.subjects.suspension);

            case 4904:
                //@ts-ignore
                return this.grantAmendment.grantAmendmentDetail.WorkflowStatusCode == 'INP' && this.$can(this.actions.update, this.subjects.termination);

            case 4905:
                //@ts-ignore
                return this.grantAmendment.grantAmendmentDetail.WorkflowStatusCode == 'INP' && this.$can(this.actions.update, this.subjects.resumeGrant);
        }
    }

    showValidation(msgs: any) {
        this.grantAmendment.validationMessages = msgs;
        this.grantAmendment.showValidationDilog = true;
    }

    rollback(e) {        
        this.getAmendmentDetail();
    }

    validationMessageClosed() {
        this.grantAmendment.showValidationDilog = false;
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }
}
